import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'core-js/stable';
import scrollPolyfill from 'scroll-polyfill';

scrollPolyfill();
